import { createContext } from 'react';
import React, {useState} from 'react';
import './App.css';
import FaucetTable from './components/FaucetTable';
import {BrowserRouter, Route, Routes} from "react-router-dom";

import NavigateLinks from './components/NavigatLinks';
import Content from './Content';
function App() {
  return (
    <>
      <BrowserRouter>
          
          <FaucetTable/>

        <Routes>

        </Routes>
        </BrowserRouter>
        
   
    </>
    
  );
}

export default App;


